/**
 * @generated SignedSource<<53f8bf0a08e45aa8b6d5e6080e8054e4>>
 * @relayHash 692b310473739d80af6d43542c26df31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b

import type { ConcreteRequest } from 'relay-runtime';
export type ContentIdByReferenceIdQuery$variables = {
  id: string;
};
export type ContentIdByReferenceIdQuery$data = {
  readonly contentIdByReferenceId: AGG$Long | null | undefined;
};
export type ContentIdByReferenceIdQuery = {
  response: ContentIdByReferenceIdQuery$data;
  variables: ContentIdByReferenceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "referenceId",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "contentIdByReferenceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentIdByReferenceIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentIdByReferenceIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "692b310473739d80af6d43542c26df31",
    "id": "80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b",
    "metadata": {},
    "name": "ContentIdByReferenceIdQuery",
    "operationKind": "query",
    "text": "query ContentIdByReferenceIdQuery($id:String!){contentIdByReferenceId(referenceId:$id)}"
  }
};
})();

(node as any).hash = "d1f8ea313ddf642c92d2df2b0f67af0d";

export default node;
